import { TBaseQuery } from "../../../../models/baseQueries/baseQuery";
import { populateTransactionId } from "../transactionIdApiExt";

export const baseQueryWithTransactionIdPopulation: (baseQuery: TBaseQuery) => TBaseQuery =
  (baseQuery: TBaseQuery) => async (args, api, extraOptions) => {
    populateTransactionId(api, extraOptions?.transactionIdScopeType);
    return await baseQuery(args, api, extraOptions);
  };
